import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'hdi-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
})
export class LogoComponent {}
